import {
  FilterDocument,
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
} from '@griply/types';

export const defaultFilterDocument: FilterDocument = {
  sortingMode: SortingMode.DeletedAt,
  groupByMode: GroupByMode.None,
  filters: {
    [FilterOptionKeys.Deleted]: true,
  },
  showCompleted: true,
};
